import { pyBackendAxiosInstance } from "../api"
import type { GongUser } from "./types"

export const getGongUsers = async (): Promise<GongUser[]> => {
  const res = await pyBackendAxiosInstance.get<GongUser[]>("/gong/users")
  return res.data
}
